import { Outlet, Link } from "react-router-dom";
import { Phone, Mail, FileText } from "lucide-react";
import { Button } from "../components/ui/button";

export default function ClaimsStatusLayout() {
  return (
    <div className="min-h-screen bg-[#F0F4F8]">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <a href="https://losspay.com" className="flex items-center gap-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_13f44300-11d0-4ec4-8a0e-9933566bed97/artifacts/6pqpojra_losspay-logo.webp" 
                alt="LossPay" 
                className="h-12 w-auto"
              />
            </a>

            {/* Navigation & Actions */}
            <div className="flex items-center gap-4 md:gap-6">
              <nav className="hidden md:flex items-center gap-6">
                <a href="https://youarenotfullycovered.com/#coverage" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900 text-sm font-medium transition-colors">
                  Coverage
                </a>
                <a href="https://youarenotfullycovered.com/#why" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900 text-sm font-medium transition-colors">
                  Why LossPay
                </a>
                <Link to="/" className="text-slate-600 hover:text-slate-900 text-sm font-medium transition-colors">
                  Claims
                </Link>
                <a href="https://youarenotfullycovered.com/#faq" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900 text-sm font-medium transition-colors">
                  FAQ
                </a>
              </nav>
              <Link to="/file-claim">
                <Button className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white gap-2 rounded-lg font-medium" data-testid="file-claim-header-btn">
                  <FileText className="w-4 h-4" />
                  <span className="hidden sm:inline">File a Claim</span>
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-200 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_13f44300-11d0-4ec4-8a0e-9933566bed97/artifacts/qnkpeio8_Asset%2049%401x.png" 
                  alt="LossPay" 
                  style={{ height: '34px', width: 'auto', filter: 'brightness(0)' }}
                />
              </div>
              <p className="text-slate-600 text-sm max-w-md leading-relaxed">
                LossPay is a vehicle value protection platform that provides diminished value protection following qualifying accident repairs. We help you recover the true value of your vehicle.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-semibold text-sm text-slate-900 mb-4">Quick Links</h3>
              <ul className="space-y-3">
                <li>
                  <a href="https://youarenotfullycovered.com" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-[#2563EB] text-sm transition-colors">
                    Home
                  </a>
                </li>
                <li>
                  <a href="https://youarenotfullycovered.com/#coverage" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-[#2563EB] text-sm transition-colors">
                    Coverage Options
                  </a>
                </li>
                <li>
                  <a href="https://youarenotfullycovered.com/#faq" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-[#2563EB] text-sm transition-colors">
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="https://losspay.com/contact" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-[#2563EB] text-sm transition-colors">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-semibold text-sm text-slate-900 mb-4">Contact Us</h3>
              <ul className="space-y-3">
                <li>
                  <a href="tel:833-567-7729" className="text-slate-600 hover:text-[#2563EB] text-sm transition-colors flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    833-LOSSPAY
                  </a>
                </li>
                <li>
                  <a href="mailto:info@losspay.com" className="text-slate-600 hover:text-[#2563EB] text-sm transition-colors flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    info@losspay.com
                  </a>
                </li>
                <li className="text-slate-600 text-sm">
                  Mon - Fri: 9am - 5pm EST
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-slate-200 mt-8 pt-8 text-center">
            <p className="text-slate-600 text-sm">
              © {new Date().getFullYear()} LossPay Risk Technologies, Inc. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
